import React, { FC } from "react";
import {
  Switch,
  FormControl,
  FormControlLabel,
  Modal,
  Typography,
  Button,
  CircularProgress,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { AddCostObj } from "../../../../GlobalTypes";
import {
  RowLayout,
  ColLayout,
  StyledModalDiv,
} from "../../../../util/accordianStyles";
import useAddCostsSelector from "./useAddCostsSelector";

interface AddCostsModalProps {
  open: boolean;
  handleClose: () => void;
  editCost: AddCostObj;
  quoteId: string;
  margin: string;
  withMarkup: boolean;
  hasDealerTax: boolean;
  isFetching: boolean;
}

const AddCostsModal: FC<AddCostsModalProps> = ({
  open,
  handleClose,
  editCost,
  quoteId,
  margin,
  withMarkup,
  hasDealerTax,
  isFetching
}) => {
  const {
    preventEnterEffects,
    handleKeyDown,
    updateCost,
    addCost,
    handleChange,
    handleCancel,
    handleCostChange,
    loading,
    checked,
    err,
    modalStyle,
    cost,
  } = useAddCostsSelector(
    handleClose,
    editCost,
    quoteId,
    margin,
    withMarkup,
    hasDealerTax,
    isFetching
  );

  const body = (
    <StyledModalDiv style={modalStyle} onKeyDown={handleKeyDown}>
      <ColLayout>
        <Typography
          variant="h4"
          style={{
            fontWeight: "bold",
            borderBottom: "1px solid black",
            width: "100%",
            paddingBottom: 10,
          }}
        >
          Additional Cost
        </Typography>

        <RowLayout style={{ paddingTop: 10 }}>
          <Typography style={{ paddingRight: 20 }}>Name:</Typography>

          <FormControl size="small">
            <OutlinedInput
              value={cost.name}
              name="name"
              onChange={handleCostChange}
              style={{ maxWidth: 150 }}
              autoComplete="false"
              onKeyDown={preventEnterEffects}
            />
          </FormControl>
        </RowLayout>

        <RowLayout style={{ paddingBottom: 10 }}>
          <Typography style={{ paddingRight: 20 }}>Amount:</Typography>

          <FormControl size="small">
            <OutlinedInput
              startAdornment={
                <InputAdornment position="start">$</InputAdornment>
              }
              value={cost.amount}
              name="amount"
              onChange={handleCostChange}
              style={{ maxWidth: 150 }}
              type="number"
              onKeyDown={preventEnterEffects}
            />
          </FormControl>
        </RowLayout>

        {!hasDealerTax && (
          <FormControl>
            <FormControlLabel
              control={
                <Switch
                  color="primary"
                  checked={checked}
                  onChange={handleChange}
                />
              }
              label="Taxable"
            />
          </FormControl>
        )}

        {err && <Typography style={{ color: "red" }}>{err}</Typography>}

        <RowLayout style={{ paddingTop: 20 }}>
          <Button
            onClick={handleCancel}
            variant="contained"
            style={{ marginRight: 10 }}
            color="inherit"
          >
            Cancel
          </Button>

          {!loading ? (
            <Button
              onClick={editCost?.price ? updateCost : addCost}
              color="primary"
              variant="contained"
              style={{ marginLeft: 10 }}
            >
              Apply
            </Button>
          ) : (
            <Button
              color="primary"
              variant="contained"
              style={{ marginLeft: 10 }}
            >
              <CircularProgress size={24} style={{ color: "white" }} />
            </Button>
          )}
        </RowLayout>
      </ColLayout>
    </StyledModalDiv>
  );

  return (
    <Modal open={open} onClose={handleCancel}>
      {body}
    </Modal>
  );
};

export default AddCostsModal;
